import React, { Component } from 'react';
import _blacklist from '../blacklist';
import _constants from '../constants';
import _classnames from 'classnames';
import { defaults } from 'lodash';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _blacklist2 = _interopRequireDefault(_blacklist);
var _classnames2 = _interopRequireDefault(_classnames);
var _constants2 = _interopRequireDefault(_constants);

class Row extends Component {
  render() {
    var gutter = this.props.gutter || _constants2['default'].width.gutter;

    var rowStyle = {
      display: 'flex',
      flexWrap: 'wrap',
      msFlexWrap: 'wrap',
      WebkitFlexWrap: 'wrap',
      marginLeft: gutter / -2,
      marginRight: gutter / -2
    };
    var className = (0, _classnames2['default'])('Row', this.props.className);
    var props = (0, _blacklist2['default'])(this.props, 'className', 'gutter', 'style');

    return React.createElement('div', _extends({}, props, { style: _extends(rowStyle, this.props.style), className: className }));
  }
};

export default Row;